import { useT } from "../i18n/index";
import type { MessageKey } from "../i18n/dictionaries";
import { Icon } from "../ui/icons";

// AC1 ships the shell + governance; the six working surfaces (AC2–AC6) replace
// these placeholders. Each is a routed, RBAC-gated landing so the shell is
// navigable end-to-end now — rendered as a tidy empty state.
export function SurfacePlaceholder({ titleKey }: { titleKey: MessageKey }) {
  const { t } = useT();
  return (
    <section className="surface">
      <header className="surface__head">
        <div>
          <h1 className="surface__title">{t(titleKey)}</h1>
        </div>
      </header>
      <div className="k-empty">
        <div className="k-empty__icon">
          <Icon name="records" size={26} />
        </div>
        <p className="k-empty__title">{t(titleKey)}</p>
        <p className="k-empty__desc">{t("placeholder.preparing")}</p>
      </div>
    </section>
  );
}
